(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dgm-navigation"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('doogee-mega-nav')) {
  class DoogeeMegaNav extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.mobile = this.dataset.mode === 'mobile';
      this.drawer = this.closest('mobile-menu-drawer');
      this.scrollContainer = this.drawer?.querySelector('.header-mobilemenu-body');
      this.viewportWidth = window.innerWidth;
      this.menus = [...this.querySelectorAll('[data-dgm-menu]')];
      this.listen = (target, name, callback, options = {}) => target.addEventListener(name, callback, { ...options, signal });
      this.listen(this, 'click', e => this.onClick(e));
      this.listen(this, 'keydown', e => this.onKey(e));
      this.listen(this, 'change', e => this.onVariant(e));
      this.listen(this, 'submit', e => this.onAdd(e));
      this.listen(document, 'pointerdown', e => { if (!this.mobile && !this.contains(e.target)) this.closeAll(); });
      this.listen(this, 'focusout', e => {
        if (this.mobile || this.pendingAdd || (e.relatedTarget && this.contains(e.relatedTarget))) return;
        clearTimeout(this.focusTimer);
        this.focusTimer = setTimeout(() => { if (!this.contains(document.activeElement)) this.closeAll(); }, 0);
      });
      this.listen(window, 'resize', () => {
        if (window.innerWidth === this.viewportWidth) return;
        this.viewportWidth = window.innerWidth;
        this.closeAll(); this.updateOrientation();
      });
      this.listen(document, 'shopify:block:select', e => {
        const target = [...this.querySelectorAll('[data-dgm-block-id]')].find(el => el.dataset.dgmBlockId === e.detail.blockId);
        const block = e.target.closest?.('.dgm-panel,.dgm-tab-panel,.dgm-promotion') || target;
        const menu = block?.closest('[data-dgm-menu]');
        if (!menu || this.mobile !== (window.innerWidth <= 1024)) return;
        this.open(menu);
        if (target) this.selectTab(target);
      });
      this.menus.forEach(menu => {
        this.listen(menu, 'toggle', () => this.sync(menu));
        this.listen(menu, 'pointerenter', e => {
          clearTimeout(this.closeTimer);
          if (!this.mobile && e.pointerType !== 'touch' && this.dataset.trigger === 'hover') {
            this.openTimer = setTimeout(() => this.open(menu), 100);
          }
        });
        this.listen(menu, 'pointerleave', () => {
          clearTimeout(this.openTimer);
          if (!this.mobile) this.closeTimer = setTimeout(() => { if (!menu.contains(document.activeElement)) this.close(menu); }, 180);
        });
      });
      if (this.drawer) {
        const closeButton = this.drawer.querySelector('[data-offcanvas-close]');
        this.drawerTrigger = document.querySelector('[data-mobile-drawer-button]');
        this.drawerTrigger?.setAttribute('aria-controls', this.drawer.id);
        this.drawerTrigger?.setAttribute('aria-expanded', 'false');
        closeButton?.setAttribute('aria-label', this.querySelector('[data-dgm-close]')?.getAttribute('aria-label') || 'Close menu');
        this.observer = new MutationObserver(() => {
          const isOpen = this.drawer.classList.contains('mobile-menu-open');
          if (isOpen === this.drawerWasOpen) return;
          this.drawerWasOpen = isOpen;
          this.drawerTrigger?.setAttribute('aria-expanded', String(isOpen));
          if (this.scrollContainer) this.scrollContainer.scrollTop = 0;
          if (isOpen) {
            this.returnFocus = this.drawerTrigger || document.activeElement;
            this.drawer.setAttribute('role', 'dialog');
            this.drawer.setAttribute('aria-modal', 'true');
            this.drawer.setAttribute('aria-label', this.getAttribute('aria-label') || 'Navigation');
            closeButton?.focus();
          } else {
            this.closeAll();
            this.drawer.removeAttribute('aria-modal');
            if (!this.handoff) this.returnFocus?.focus();
            this.handoff = false;
          }
        });
        this.observer.observe(this.drawer, { attributes: true, attributeFilter: ['class'] });
        this.listen(this.drawer, 'keydown', e => {
          if (!this.drawer.classList.contains('mobile-menu-open')) return;
          if (e.key === 'Escape') {
            e.preventDefault(); e.stopPropagation();
            const openMenu = this.menus.find(menu => menu.open);
            if (openMenu) this.close(openMenu, true); else closeButton?.click();
          }
          if (e.key !== 'Tab') return;
          const items = this.focusable(this.drawer);
          if (!items.length) return;
          if (e.shiftKey && document.activeElement === items[0]) { e.preventDefault(); items.at(-1).focus(); }
          else if (!e.shiftKey && document.activeElement === items.at(-1)) { e.preventDefault(); items[0].focus(); }
        });
      }
      this.updateOrientation();
    }
    disconnectedCallback() {
      this.controller?.abort(); this.observer?.disconnect();
      clearTimeout(this.openTimer); clearTimeout(this.closeTimer); clearTimeout(this.focusTimer);
    }
    focusable(root) {
      return [...root.querySelectorAll('a[href],button:not([disabled]),summary,select,[tabindex="0"]')].filter(el => el.getClientRects().length && !el.closest('[hidden]'));
    }
    updateOrientation() {
      this.querySelectorAll('[role=tablist]').forEach(el => el.setAttribute('aria-orientation', this.mobile ? 'horizontal' : 'vertical'));
    }
    open(menu) {
      clearTimeout(this.closeTimer);
      this.menus.forEach(other => { if (other !== menu) this.close(other); });
      menu.open = true;
      if (this.scrollContainer) this.scrollContainer.scrollTop = 0;
      const header = this.closest('[header-main]');
      if (header) this.style.setProperty('--dgm-top', `${Math.max(0, header.getBoundingClientRect().bottom)}px`);
      this.sync(menu);
      this.mount(menu.querySelector('[data-dgm-tab-panel]:not([hidden])'));
    }
    close(menu, restore = false) {
      menu.open = false;
      this.sync(menu);
      if (restore) {
        if (this.scrollContainer) this.scrollContainer.scrollTop = 0;
        menu.querySelector(':scope > summary').focus({ preventScroll: this.mobile });
      }
    }
    closeAll() { this.menus.forEach(menu => this.close(menu)); }
    sync(menu) {
      menu.querySelector(':scope > summary')?.setAttribute('aria-expanded', String(menu.open));
      this.querySelector('.dgm-top-list')?.classList.toggle('dgm-has-open', this.menus.some(item => item.open));
      const backdrop = this.querySelector('[data-dgm-backdrop]'); if (backdrop) backdrop.hidden = !this.menus.some(item => item.open);
      if (menu.open) this.mount(menu.querySelector('[data-dgm-tab-panel]:not([hidden])'));
      if (!menu.open && this.mobile) menu.querySelectorAll('[data-dgm-child]').forEach(el => { el.open = false; el.querySelector('summary').setAttribute('aria-expanded', 'false'); el.closest('.dgm-link-columns')?.classList.remove('dgm-child-open'); });
    }
    mount(panel) {
      const template = panel?.querySelector('template[data-dgm-products-template]');
      if (!template) return;
      template.replaceWith(template.content.cloneNode(true));
    }
    selectTab(tab, focus = false) {
      const group = tab.closest('.dgm-tabs');
      group.querySelectorAll('[data-dgm-tab]').forEach(item => {
        const active = item === tab;
        item.setAttribute('aria-selected', String(active)); item.tabIndex = active ? 0 : -1;
        const panel = document.getElementById(item.getAttribute('aria-controls'));
        if (panel) { panel.hidden = !active; if (active) this.mount(panel); }
      });
      if (focus) { tab.focus(); tab.scrollIntoView({ block: 'nearest', inline: 'nearest' }); }
    }
    onClick(e) {
      if (e.target.matches('[data-dgm-backdrop]')) { this.closeAll(); return; }
      const summary = e.target.closest('[data-dgm-menu] > summary');
      if (summary && this.contains(summary)) {
        e.preventDefault();
        const menu = summary.parentElement;
        if (menu.open) this.close(menu); else { this.open(menu); if (this.mobile) menu.querySelector('[data-dgm-back]')?.focus({ preventScroll: true }); }
        return;
      }
      const tab = e.target.closest('[data-dgm-tab]');
      if (tab) { this.selectTab(tab); return; }
      const back = e.target.closest('[data-dgm-back],[data-dgm-close]');
      if (back) { this.close(back.closest('[data-dgm-menu]'), true); return; }
      const childSummary = e.target.closest('[data-dgm-child] > summary');
      if (childSummary && this.mobile) {
        e.preventDefault(); const child = childSummary.parentElement;
        child.open = !child.open; childSummary.setAttribute('aria-expanded', String(child.open));
        child.closest('.dgm-link-columns').classList.remove('dgm-child-open');
      }
      const childBack = e.target.closest('[data-dgm-child-back]');
      if (childBack) this.closeChild(childBack.closest('[data-dgm-child]'));
      const quickView = e.target.closest('[data-dgm-quick-view]');
      if (quickView) {
        const returnTarget = this.mobile ? this.returnFocus : quickView.closest('[data-dgm-menu]')?.querySelector(':scope > summary');
        this.dismissForDrawer();
        quickView.classList.remove('click-focus-element');
        returnTarget?.classList.add('click-focus-element');
      }
    }
    closeChild(child) {
      child.open = false; child.closest('.dgm-link-columns').classList.remove('dgm-child-open');
      const summary = child.querySelector('summary'); summary.setAttribute('aria-expanded', 'false'); summary.focus();
    }
    onKey(e) {
      const tab = e.target.closest('[data-dgm-tab]');
      if (tab && ['ArrowDown','ArrowUp','ArrowLeft','ArrowRight','Home','End'].includes(e.key)) {
        const tabs = [...tab.closest('[role=tablist]').querySelectorAll('[role=tab]')];
        let index = tabs.indexOf(tab);
        if (e.key === 'Home') index = 0;
        else if (e.key === 'End') index = tabs.length - 1;
        else index = (index + (['ArrowDown','ArrowRight'].includes(e.key) ? 1 : -1) + tabs.length) % tabs.length;
        e.preventDefault(); this.selectTab(tabs[index], true); return;
      }
      const summary = e.target.closest('[data-dgm-menu] > summary');
      if (summary && e.key === 'ArrowDown') {
        e.preventDefault(); this.open(summary.parentElement);
        this.focusable(summary.parentElement.querySelector('.dgm-panel'))[0]?.focus();
      }
      if (e.key === 'Escape') {
        const child = e.target.closest('[data-dgm-child][open]');
        const menu = e.target.closest('[data-dgm-menu][open]');
        if (child && this.mobile) { e.preventDefault(); e.stopPropagation(); this.closeChild(child); }
        else if (menu) { e.preventDefault(); e.stopPropagation(); this.close(menu, true); }
      }
    }
    onVariant(e) {
      if (!e.target.matches('[data-dgm-variant]')) return;
      const option = e.target.selectedOptions[0]; const card = e.target.closest('[data-dgm-product]');
      const price = card.querySelector('[data-dgm-price]'); if (price) price.textContent = option.dataset.price;
      const compare = card.querySelector('[data-dgm-compare]'); if (compare) { compare.textContent = option.dataset.compare; compare.hidden = !option.dataset.compare; }
      const badge = card.querySelector('[data-dgm-sale]'); if (badge) { badge.textContent = `-${option.dataset.sale}%`; badge.hidden = !option.dataset.sale; }
      const button = card.querySelector('[data-dgm-submit]'); if (button) { button.disabled = option.dataset.available !== 'true'; button.textContent = button.disabled ? this.dataset.soldLabel : this.dataset.addLabel; }
      card.querySelectorAll('[data-dgm-product-link]').forEach(link => link.href = option.dataset.url);
      const image = card.querySelector('.dgm-primary-image'); if (image && option.dataset.image) { image.src = option.dataset.image; image.removeAttribute('srcset'); }
      const error = card.querySelector('[data-dgm-error]'); if (error) error.hidden = true;
    }
    dismissForDrawer() {
      this.closeAll();
      if (this.drawer?.classList.contains('mobile-menu-open')) { this.handoff = true; this.drawer.querySelector('[data-offcanvas-close]')?.click(); }
    }
    async onAdd(e) {
      const form = e.target.closest('[data-dgm-add]'); if (!form || !this.contains(form)) return;
      const button = form.querySelector('[data-dgm-submit]'); if (!button || button.disabled || this.pendingAdd) { e.preventDefault(); return; }
      e.preventDefault(); this.pendingAdd = true; button.disabled = true; button.setAttribute('aria-busy', 'true'); button.textContent = this.dataset.addingLabel;
      const error = form.querySelector('[data-dgm-error]'); error.hidden = true;
      const cart = document.querySelector('cart-drawer'); const body = new FormData(form);
      const root = window.Shopify?.routes?.root || '/';
      const sections = cart?.getSectionsToRender?.() || [];
      if (sections.length) { body.append('sections', [...new Set(sections.map(section => section.id))].join(',')); body.append('sections_url', window.location.pathname); }
      let added = false;
      try {
        const response = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || result.message || this.dataset.errorLabel);
        added = true;
        this.dismissForDrawer();
        const trigger = document.querySelector('[data-cart]') || this.returnFocus;
        document.querySelectorAll('.prev-focuse-element').forEach(el => el.classList.remove('prev-focuse-element'));
        trigger?.classList.add('prev-focuse-element'); cart?.setActiveElement?.(trigger);
        if (cart?.renderContents && sections.every(section => result.sections?.[section.id])) {
          cart.classList.remove('is-empty'); cart.renderContents(result);
          const pubsub = await import('@lib/pubsub');
          pubsub.publish(pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'dgm-menu', productVariantId: body.get('id'), cartData: result });
        } else window.location.assign(`${root}cart`);
      } catch (issue) {
        if (added) window.location.assign(`${root}cart`);
        else { error.textContent = issue.message || this.dataset.errorLabel; error.hidden = false; }
      } finally {
        this.pendingAdd = false; button.disabled = false; button.removeAttribute('aria-busy'); button.textContent = this.dataset.addLabel;
      }
    }
  }
  customElements.define('doogee-mega-nav', DoogeeMegaNav);
}
  } catch(e) { console.error(e); }
})();

})();
